export function prodDataDogTracings() {
  return ['https://marketiq.cbre.com', /https:\/\/.*\.marketiq\.cbre.com/];
}

export function qaDataDogTracings() {
  return ['https://qa.marketiq.cbre.com', /https:\/\/.*\.qa\.marketiq\.cbre.com/];
}

export function uatDataDogTracings() {
  return ['https://uat.marketiq.cbre.com', /https:\/\/.*\.uat\.marketiq\.cbre.com/];
}
